import { Sun, Moon, SunMoon, Check } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const MODES = [
  { value: "light", label: "Light", hint: "Bright UI, always", Icon: Sun },
  { value: "dark", label: "Dark", hint: "Dark UI, always", Icon: Moon },
  { value: "auto", label: "Auto", hint: "Dark at night, light by day", Icon: SunMoon },
];

export const ThemeToggle = ({ className = "" }) => {
  const { mode, setMode, isDark } = useTheme();
  const CurrentIcon = mode === "auto" ? SunMoon : isDark ? Moon : Sun;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="theme-toggle-btn"
          aria-label="Change theme"
          className={`inline-flex items-center justify-center w-9 h-9 rounded-full border border-ink-200 bg-white text-ink-700 hover:border-ink-950 hover:text-ink-950 transition-colors ${className}`}
        >
          <CurrentIcon className="w-4 h-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {MODES.map(({ value, label, hint, Icon }) => (
          <DropdownMenuItem
            key={value}
            data-testid={`theme-${value}-option`}
            onClick={() => setMode(value)}
            className="flex items-center gap-3 py-2.5 cursor-pointer"
          >
            <Icon className="w-4 h-4 text-ink-500" />
            <span className="flex-1">
              <span className="block text-sm font-semibold">{label}</span>
              <span className="block text-xs text-ink-500">{hint}</span>
            </span>
            {mode === value && <Check className="w-4 h-4 text-coral-500" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
